import { jwtDecode } from "jwt-decode";
import { getAccessTokenCookie } from "@utils/access-token-cookie";

type AccessTokenClaims = { originalAdminId?: string };

export const getOriginalAdminIdFromAccessToken = (): string | null => {
  const token = getAccessTokenCookie();
  if (!token) return null;
  try {
    return jwtDecode<AccessTokenClaims>(token).originalAdminId ?? null;
  } catch {
    return null;
  }
};
